import React, { useEffect, useState } from "react";
import { ScrollView, View, Text, StyleSheet, SafeAreaView, TouchableOpacity, StatusBar, Platform, Pressable } from "react-native";
import { ProductList, QuickAccess } from "./components";
import { useTheme } from "../../context/ThemeContext";
import { useDesign } from "../../context/DesignContext";
import { useContent } from "../../context/ContentContext";
import { mockProductsData } from "./mockData";
import { Ionicons } from "@expo/vector-icons";
import { withComponentEditor } from "../BaseComponent";
import { useNavigation } from "@react-navigation/native";

console.log(Platform.OS);

const componentType = "productsPage";
const ProductsPage = ({ content = {}, onComponentSelect }) => {
	const theme = useTheme();
	const styles = useStyles();
	const navigation = Platform.OS !== "web" ? useNavigation() : null;
	const [loading, setLoading] = useState(false);
	const { products = [] } = mockProductsData;
	const { fetchContent, contentSnapshot } = useContent();
	const pageContent = fetchContent(componentType) || {};
	const [user, setUser] = useState({ roles: ["demo"] });

	const handleSelectProduct = (product) => {
		if (navigation) {
			navigation.navigate("ProductDetail", { product });
		}
	};

	const handleProductEditor = () => {
		if (onComponentSelect) {
			onComponentSelect({
				componentType,
				sections: [
					{
						id: "general",
						title: "General Settings",
						properties: ["pageTitle", "pageIcon"],
					},
					{
						id: "products",
						title: "Products Configuration",
						properties: ["products.whoCanCreate", "productItem.labelSingular", "productItem.labelPlural", "productItem.icon", "productDetail.howToBuy", "productDetail.icon"],
					},
				],
				properties: {
					// General Settings
					pageTitle: {
						store: "content",
						type: "text",
						label: "Page Title",
						description: "The title of what your product page will be about. (e.g. Products, Books..., etc.)",
						value: "Products",
					},
					pageIcon: {
						store: "content",
						type: "icon",
						label: "Page Icon",
						description: "The icon of what your product page will be about. (e.g. Products, Books..., etc.)",
					},

					// Posts Configuration
					"products.whoCanCreate": {
						store: "content",
						type: "dropdown",
						label: "Who Can Create Products",
						description: "User roles who can create products",
						options: "userRoles",
					},
					"productItem.labelSingular": {
						store: "content",
						type: "text",
						label: "Product Item Label Singular",
						description: "The singular label for the product item",
					},
					"productItem.labelPlural": {
						store: "content",
						type: "text",
						label: "Product Item Label Plural",
						description: "The plural label for the product item",
					},
					"productDetail.howToBuy": {
						store: "content",
						type: "text",
						label: "Add to Cart Text",
						description: "The text for the add to cart button",
					},
					"productDetail.icon": {
						store: "content",
						type: "icon",
						label: "Product Detail Icon",
						description: "The icon for the product detail page",
						value: "bookmark",
					},
				},
			});
		}
	};
	const handleCreateProduct = () => {
		if (navigation) {
			navigation.navigate("ProductCreate");
		}
	};

	const handleEndReached = () => {
		// In a real app, this would load more products
		console.log("End reached, load more products");
	};

	return (
		<SafeAreaView style={styles.container}>
			<StatusBar barStyle="dark-content" />
			<Pressable style={styles.header} onPress={handleProductEditor}>
				<Text style={styles.title}>{pageContent.pageTitle}</Text>
				<View style={styles.headerActions}>
					{["admin", "demo"].some((role) => user.roles.includes(role)) && (
						<TouchableOpacity style={styles.headerButton} onPress={handleCreateProduct}>
							<Ionicons name="add" size={26} color={theme.colors.primary} />
						</TouchableOpacity>
					)}
				</View>
			</Pressable>

			<ProductList products={products} onSelectProduct={handleSelectProduct} loading={loading} onEndReached={handleEndReached} />
		</SafeAreaView>
	);
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		container: {
			flex: 1,
			backgroundColor: theme.colors.systemBackground.primary,
		},
		header: {
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
			paddingHorizontal: theme.spacing.md,
			paddingVertical: theme.spacing.md,
		},
		title: {
			...theme.typography.title1,
			color: theme.colors.text,
			marginBottom: theme.spacing.sm,
		},
		headerActions: {
			flexDirection: "row",
			alignItems: "center",
		},
		headerButton: {
			width: 40,
			height: 40,
			justifyContent: "center",
			alignItems: "center",
			borderRadius: 20,
		},
		fabContainer: {
			position: "absolute",
			bottom: theme.spacing.lg,
			right: theme.spacing.md,
			alignItems: "flex-end",
		},
		fab: {
			width: 56,
			height: 56,
			borderRadius: 28,
			backgroundColor: theme.colors.primary,
			justifyContent: "center",
			alignItems: "center",
			...theme.shadows.md,
		},
		fabMenu: {
			marginBottom: theme.spacing.sm,
		},
		fabItem: {
			backgroundColor: theme.colors.systemBackground.primary,
			borderRadius: theme.borderRadius.md,
			marginBottom: theme.spacing.xs,
			padding: theme.spacing.sm,
			...theme.shadows.sm,
			width: 200,
		},
		fabItemContent: {
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
		},
		fabItemText: {
			...theme.typography.subhead,
			color: theme.colors.text,
			fontWeight: "500",
		},
	});
};

const ProductsPageWrapper = (props) => {
	const { fetchComponentData } = props;
	const componentData = fetchComponentData?.("products") || { content: {} };

	return <ProductsPage {...props} {...componentData} />;
};

export default Platform.OS === "web" ? withComponentEditor(ProductsPageWrapper) : ProductsPageWrapper; // Or any other mobile-specific version
